import { AcaoReuniao } from "./acao-reuniao";
import { ParticipanteReuniao } from "./participante-reuniao";
import { PessoaFisica } from "./pessoa-fisica";
import { TipoReuniao } from "./tipo-reuniao";

export class Reuniao {
    id: number;
    numeroReuniao: string;
    tema: string;
    local: string;
    pauta: string;
    apontamentos: string;
    localProximaReuniao: string;
    dataInicio: Date;
    dataFim: Date;
    dataProximaReuniao: Date;
    horaProximaReuniao?: string;
    horaInicio: string;
    horaFim: string;
    area: string;

    relator: PessoaFisica;
    participantes: ParticipanteReuniao[];
    acoesReuniao: AcaoReuniao[];
    tipoReuniao: TipoReuniao
}
